module.exports = __webpack_public_path__ + "static/media/4_My_List_Detail.a08026b9.png";